import { render, staticRenderFns } from "./GradingPaper.vue?vue&type=template&id=78dac631&scoped=true"
import script from "./GradingPaper.vue?vue&type=script&lang=js"
export * from "./GradingPaper.vue?vue&type=script&lang=js"
import style0 from "./GradingPaper.vue?vue&type=style&index=0&id=78dac631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dac631",
  null
  
)

export default component.exports